// 3rd party imports
import * as React from 'react';
import { Link } from 'react-router-dom';
import { LocalizedComponentProps, LocalizedText } from '@shared-ui/localization-context';

// bernie
import { ContextStore, AnalyticsStore } from 'bernie-plugin-mobx';

// ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkList, UitkListItem } from 'uitk-react-list';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { UitkLink } from 'uitk-react-link';

// util
import { modifyLocaleParam } from '../util/locale-param-transformer';
import { getUserAnalyticsMicroMessage } from '../util/analytics';

import { UserAuthStore, PzStore } from 'src/stores';
import { useStores } from '../hooks';

export interface NotFoundMessageProps extends LocalizedComponentProps {
  context?: ContextStore;
  analytics?: AnalyticsStore;
  userAuth?: UserAuthStore;
  pzStore?: PzStore;
}

export const NotFoundMessage: React.FunctionComponent = () => {
  const { context, analytics, userAuth, pzStore } = useStores();

  if (typeof window !== 'undefined') {
    // tslint:disable-next-line:no-console
    console.log('Tried to hit: ' + window.location);
  }

  const referrerHomeId = 'affhub_error_page.home.selected';
  const linkNameHome = 'AffHub Error page Home Selected';
  const referrerSigninId = 'affhub_error_page.signin.selected';
  const linkNameSignin = 'AffHub Error page Signin Selected';
  const referrerSignupId = 'affhub_error_page.signup.selected';
  const linkNameSignup = 'AffHub Error page Signup Selected';

  const analyticsErrorpageHome = {
    id: referrerHomeId,
    callback: () => {
      if (analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent(referrerHomeId, linkNameHome, null, null, true, [
          getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
        ]);
      }
    },
  };

  const analyticsErrorpageSignin = {
    id: referrerSigninId,
    callback: () => {
      if (analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent(referrerSigninId, linkNameSignin, null, null, true, [
          getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
        ]);
      }
    },
  };

  const analyticsErrorpageSignup = {
    id: referrerSignupId,
    callback: () => {
      if (analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent(referrerSignupId, linkNameSignup, null, null, true, [
          getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
        ]);
      }
    },
  };

  const urlFor = (suffix: string) => ['', modifyLocaleParam(context.locale), suffix].join('/');

  return (
    <UitkSpacing className="container" padding={{ block: 'twelve' }}>
      <UitkLayoutGrid columns={12} space="three">
        <UitkLayoutGridItem colSpan={7}>
          <UitkLayoutFlex space="four" direction="column">
            <UitkHeading tag="h1" size={2}>
              Oops!
            </UitkHeading>
            <UitkText size={700}>We can&apos;t seem to find the page you&apos;re looking for.</UitkText>
            <UitkText size={400} weight="bold">
              Error Code: 404
            </UitkText>
            <UitkSpacing padding={{ inlinestart: 'one' }}>
              <div>
                <UitkSubheading>Here are some helpful links instead:</UitkSubheading>
                <UitkSpacing margin="one">
                  <UitkList bullet="no-bullet">
                    <UitkListItem key="">
                      <UitkLink analytics={analyticsErrorpageHome}>
                        <Link to={urlFor('home')}>
                          <LocalizedText message="error.content.home" />
                        </Link>
                      </UitkLink>
                    </UitkListItem>
                    <UitkListItem key="">
                      <UitkLink analytics={analyticsErrorpageSignin}>
                        <Link to={urlFor('signin')}>
                          <LocalizedText message="common.sign_in" />
                        </Link>
                      </UitkLink>
                    </UitkListItem>
                    <UitkListItem key="">
                      <UitkLink analytics={analyticsErrorpageSignup}>
                        <Link to={urlFor('signup')}>
                          <LocalizedText message="common.join_now" />
                        </Link>
                      </UitkLink>
                    </UitkListItem>
                  </UitkList>
                </UitkSpacing>
              </div>
            </UitkSpacing>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem colSpan={5}>
          <div style={{ height: '360px' }}>
            <UitkFigure className="all-image-fit-contain">
              <UitkImage alt="Expedia Group Affiliate Program" src="/images/questions_guide.png" />
            </UitkFigure>
          </div>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkSpacing>
  );
};
